import React, { useEffect, useState } from "react";
import { Redirect } from "react-router";

import RedirectService from "../service/redirect-service";

export default () => {
  const [redirectObj, setRedirectObj] = useState({ to: "", time: 0 });
  const { time, to } = redirectObj;
  useEffect(() => {
    const redirector = (toRoute) => {
      setRedirectObj({ to: toRoute, time: new Date().getTime() });
    };
    RedirectService.register(redirector);
  }, [time]);

  return <>{to && <Redirect push to={to} />}</>;
};
